export default function () {
  return {
    restrict: 'A',
    priority: -1,
    require: 'ngModel',
    link: function (scope, elem, attrs, ngModel) {
      var name = elem[0].name;
      name = name.replace(/\{\{\$index\}\}/g, scope.$index);
      
      ngModel.$name = name;
    }
  };
}



// WEBPACK FOOTER //
// ./src/login/forminputname.directive.js